import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {isBrowser} from "react-device-detect";
import {
    closePharmacyOrderGeneralAcceptModal,
    closePharmacyOrderRejectModal, openPharmacyOrderAcceptModal,openPharmacyOrderPartialModal   
} from "../../../../redux/actions/modals";
import LargeModal from "../../../../components/modals/LargeModal";
import CustomButton from "../../../../components/CustomButton";
import {rejectPharmacyOrder} from "../../../../redux/actions/orders";
import PharmacyOrderPartialComponent from './PharmacyOrderPartialComponent'

const PharmacyOrderGeneralAcceptComponent = (props) => {
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [rejectData, setRejectData] = useState({
        reason: 'PRESCRIPTION_CORRUPTED',
        more_description: ''
    });
    const {
        pharmacy_order_general_accept_open,
        pharmacy_order_general_accept_order,
    } = useSelector((state) => state.modals);
    
    const renderPartialOrderBtns = () => {
        if(Object.keys(pharmacy_order_general_accept_order).length !== 0){
            const order = pharmacy_order_general_accept_order
            if(order.prescriptions.length !== 0 && order.prescriptions !== undefined && order.prescriptions !== null) {
                if(order.prescriptions.length > 1 || order.prescriptions[0].tag !== "OTC") {
                    return (
                        <div className="partial-order-btn-holder w-100">
                        <button
                            className="btn btn-small btn-success btn-accept margin-bottom-5"
                            onClick={() => {
                                dispatch(openPharmacyOrderPartialModal(props, 'simple'));
                            }}
                        >
                            <div className="title">
                            قبول سفارش به صورت موردی
                            </div>
                            <div className="sub-title">
                            در صورت ناموجود بودن یک یا چند مورد از اقلام سفارش
                            </div>
                        </button>
                    </div>
                    )
                }
            }
        }

    }

    return (
        <>
            <LargeModal
                header="تایید نسخه"
                show={pharmacy_order_general_accept_open}
                closeFunction={closePharmacyOrderGeneralAcceptModal}
            >
                <div className="pharmacy-actions-buttons" style={{
                    display:'flex',
                    flexDirection:'column'
                }}>
                    <button
                        className="btn btn-small btn-success btn-accept margin-bottom-5"
                        onClick={() => {
                            dispatch(openPharmacyOrderAcceptModal(pharmacy_order_general_accept_order, 'simple'));
                        }}
                    >
                        <div className="title">
                            قبول نسخه به صورت عادی
                        </div>
                        <div className="sub-title">
                            (پیک یک طرفه بدون نیاز به نسخه)
                        </div>
                    </button>
                    <button
                        className="btn btn-small btn-success btn-accept margin-bottom-5"
                        onClick={() => {
                            dispatch(openPharmacyOrderAcceptModal(pharmacy_order_general_accept_order,'insurance'));
                        }}
                    >
                        <div className="title">
                            قبول نسخه تحت پوشش بیمه
                        </div>
                        <div className="sub-title">
                            (پیک رفت و برگشت اختیاری جهت دریافت اصل نسخه)
                        </div>
                    </button>
                    <button
                        className="btn btn-small btn-success btn-accept margin-bottom-5"
                        onClick={() => {
                            dispatch(openPharmacyOrderAcceptModal(pharmacy_order_general_accept_order,'special'));
                        }}
                    >
                        <div className="title">
                            قبول نسخه داروی خاص
                        </div>
                        <div className="sub-title">
                            (پیک رفت و برگشت الزامی جهت دریافت اصل نسخه)
                        </div>
                    </button>
                    {renderPartialOrderBtns()}
                </div>
            </LargeModal>
            <PharmacyOrderPartialComponent order={pharmacy_order_general_accept_order} />
        </>
    );
};
export default PharmacyOrderGeneralAcceptComponent;
